import {
    CustomerTestimonials,
    TestimonialProps
} from "@/libraries/design/patterns/customer-testimonials/src/customer-testimonials";

export type UniformCustomerTestimonialsProps = {
    theme: "black" | "white";
    quotes: {
        fields: {
            organization: {
                fields: {
                    organizationNameExternal: string;
                    logo: {
                        fields: UniformContentfulImage;
                    }[];
                };
            };
            advocateName: string;
            advocateJobTitle: string;
            advocateHeadshot: {
                fields: UniformContentfulImage;
            };
            advocateQuote: string;
            advocateCta: {
                fields: {
                    ctaUrl: string;
                    ctaButtonText: string;
                };
            }[];
        };
    }[];
};

type UniformContentfulImage = {
    file: {
        contentType: "string";
        url: string;
        details: {
            image: {
                width: number;
                height: number;
            };
        };
    };
};

const transformImage = (props: UniformContentfulImage, alt?: string) => {
    if (!props) {
        return undefined;
    }
    return {
        contentType: props.file?.contentType,
        src: props.file?.url,
        alt: alt ?? "",
        baseWidth: 500,
        width: props.file?.details?.image?.width,
        height: props.file?.details?.image?.height
    };
};
const transformCta = (linkUrl?: string, linkText?: string) => {
    if (linkUrl && linkText) {
        return {
            url: linkUrl,
            text: linkText
        };
    }
    return undefined;
};
const transformProps = (props: UniformCustomerTestimonialsProps) => {
    return {
        bgColor: props.theme ?? "white",
        testimonials: props.quotes
            .map((quote) => {
                const fields = quote.fields;
                const linkUrl = fields.advocateCta?.[0]?.fields?.ctaUrl;
                const linkText = fields.advocateCta?.[0]?.fields?.ctaButtonText;

                return {
                    logo: transformImage(
                        fields.organization?.fields?.logo?.[0]
                            ?.fields as UniformContentfulImage,
                        fields.organization?.fields?.organizationNameExternal
                    ),
                    name: fields.advocateName,
                    title: fields.advocateJobTitle,
                    image: transformImage(fields.advocateHeadshot?.fields),
                    quote: fields.advocateQuote,
                    link: transformCta(linkUrl, linkText)
                } as TestimonialProps;
            })
            .filter((quote) => {
                return (
                    !!quote.logo &&
                    !!quote.name &&
                    !!quote.title &&
                    !!quote.image &&
                    !!quote.quote
                );
            })
    };
};

const UniformCustomerTestimonials = (
    props: UniformCustomerTestimonialsProps
) => {
    //TODO GWP-6632: add CTA links, and ensure they are localized in each panel

    const transformed = transformProps(props);

    return (
        <CustomerTestimonials
            bgColor={transformed.bgColor}
            testimonials={transformed.testimonials}
        />
    );
};

export default UniformCustomerTestimonials;
